/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Stats_VideosInputs */

const en_course_stats_videos = /** @type {(inputs: Course_Stats_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos`)
};

const ja_course_stats_videos = /** @type {(inputs: Course_Stats_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画`)
};

const fr_course_stats_videos = /** @type {(inputs: Course_Stats_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéos`)
};

const de_course_stats_videos = /** @type {(inputs: Course_Stats_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos`)
};

/**
* | output |
* | --- |
* | "Videos" |
*
* @param {Course_Stats_VideosInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_stats_videos = /** @type {((inputs?: Course_Stats_VideosInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Stats_VideosInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_stats_videos(inputs)
	if (locale === "ja") return ja_course_stats_videos(inputs)
	if (locale === "fr") return fr_course_stats_videos(inputs)
	return de_course_stats_videos(inputs)
});